webpackJsonp([263791100135453],{

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/interior_sunset_3.f1633b98.jpg";

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sheila.ce2e4388.jpg";

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sisters.97440c9a.jpg";

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _aboutModule = __webpack_require__(415);
	
	var _aboutModule2 = _interopRequireDefault(_aboutModule);
	
	var _interior_sunset_ = __webpack_require__(541);
	
	var _interior_sunset_2 = _interopRequireDefault(_interior_sunset_);
	
	var _sheila = __webpack_require__(542);
	
	var _sheila2 = _interopRequireDefault(_sheila);
	
	var _sisters = __webpack_require__(543);
	
	var _sisters2 = _interopRequireDefault(_sisters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import backgroundImg from '../images/background1.jpg'
	
	var About = function About() {
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%' } },
	    _react2.default.createElement(
	      'div',
	      { className: _aboutModule2.default.container },
	      _react2.default.createElement('div', { className: _aboutModule2.default.topBack, style: { msGridRow: 1 } }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_aboutModule2.default.contentContainer), style: { msGridColumn: 2 } },
	        _react2.default.createElement(
	          'div',
	          { className: _aboutModule2.default.topPhoto },
	          _react2.default.createElement('img', { src: _interior_sunset_2.default, alt: 'greenhouse at sunset' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _aboutModule2.default.topPanel },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Every project is different. We take pride in growing our plants to match your needs.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _aboutModule2.default.sheila },
	          _react2.default.createElement('img', { src: _sheila2.default, alt: 'sheila' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _aboutModule2.default.aboutText },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h2',
	              { className: _aboutModule2.default.aboutH2 },
	              'Trillium Gardens is a wholesale grower near Eugene, Oregon, specializing in Pacific Northwest native plants. We grow hundreds of species of native trees, shrubs, ferns, wetland plants, wild flowers, and ground covers. Plants are available in plugs, containers, and bare root.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _aboutModule2.default.aboutTextMobile },
	          _react2.default.createElement(
	            'h2',
	            { className: _aboutModule2.default.aboutH2 },
	            'About Us'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _aboutModule2.default.aboutP },
	            'Trillium Gardens is a wholesale grower near Eugene, Oregon, specializing in Pacific Northwest native plants. We grow hundreds of species of native trees, shrubs, ferns, wetland plants, wild flowers, and ground covers. Plants are available in plugs, containers, and bare root.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _aboutModule2.default.storyText },
	          _react2.default.createElement(
	            'h2',
	            { className: _aboutModule2.default.aboutH2 },
	            'Our Story'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _aboutModule2.default.aboutP },
	            'Trillium Gardens was founded by Sheila Klest near Eugene, Oregon.  Sheila has a love for and extensive knowledge of plants native to the Pacific Northwest.  She has been asked to give many presentations on gardening and the ethnobotany of native plants.  She also writes and collaborates on articles for native plant journals and works with regional botanists to study native plant habitats. ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'For over 25 years, Trillium Gardens has been providing plants to landscape contractors, public and private agencies, nurseries, and garden centers. We have had many of the same loyal customers since the nursery was founded and continue to welcome new clients. We value these relationships and the opportunity to work closely with each customer to meet their needs and address the challenges of their project, whether big or small. ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Our plants have been used in large bio-remediation projects, along highway corridors, in wetland and natural area restoration, and in parks and landscapes. Some of our customers include the Forest Service, the Army Corps of Engineers, the Bureau of Land Management, Clean Water Services, The Nature Conservancy, Watershed Councils, The Fresh Water Trust, and many more.'
	          )
	        ),
	        _react2.default.createElement('div', { className: _aboutModule2.default.sisters, style: { backgroundImage: 'url(' + _sisters2.default + ')' } }),
	        _react2.default.createElement(
	          'div',
	          { className: _aboutModule2.default.environmentText },
	          _react2.default.createElement(
	            'h2',
	            { className: _aboutModule2.default.aboutH2 },
	            'Healthy Environment'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _aboutModule2.default.aboutP },
	            'As a commitment to our environment, we use organic fertilizers and disease-control methods almost exclusively. We hand-weed our plants, and we reuse and recycle our containers and other materials. Trillium Gardens has received the RE-THINK certification in sustainability from BRING.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _aboutModule2.default.reachOutText },
	          _react2.default.createElement(
	            'h2',
	            { className: _aboutModule2.default.aboutH2 },
	            'Reach Out'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _aboutModule2.default.aboutP },
	            'Please don\u2019t hesitate to call with any questions about your specific project or native plants in general. We welcome your questions and are always happy to help!'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _aboutModule2.default.contact },
	          _react2.default.createElement(
	            'a',
	            { href: 'tel:541-937-5413' },
	            _react2.default.createElement(
	              'h2',
	              { className: _aboutModule2.default.aboutH2 },
	              'call: 541-937-5413'
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:sales@trilliumgardens.com' },
	            _react2.default.createElement(
	              'h2',
	              { className: _aboutModule2.default.aboutH2 },
	              'sales@trilliumgardens.com'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	// import Layout from '../layouts/index'
	exports.default = About;
	module.exports = exports['default'];

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"aboutTextMobile":"src-pages----about-module---aboutTextMobile---cLir6","aboutH2":"src-pages----about-module---aboutH2---38V6O","aboutP":"src-pages----about-module---aboutP---3_JNc","container":"src-pages----about-module---container---1ewHF","contentContainer":"src-pages----about-module---contentContainer---33Kjk","topBack":"src-pages----about-module---topBack---2vTt9","topPhoto":"src-pages----about-module---topPhoto---3ZJix","topPanel":"src-pages----about-module---topPanel---3nsX0","sheila":"src-pages----about-module---sheila---3MWyp","aboutText":"src-pages----about-module---aboutText---24Upq","storyText":"src-pages----about-module---storyText---2vkJW","sisters":"src-pages----about-module---sisters---33_Q0","environmentText":"src-pages----about-module---environmentText---3Tqca","reachOutText":"src-pages----about-module---reachOutText---3mELS","contact":"src-pages----about-module---contact---MBhLV"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-63f221033f8bac1b6bc0.js